<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.tech_crm" label="CRM Software"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.tech_portfolio_rebalancing" label="Portfolio Rebalancing Software"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.tech_account_aggregation" label="Account Aggregation Software"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.tech_accounting" label="Accounting Software"></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
             <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.tech_financial_planning" label="Financial Planning Software"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.tech_document_management" label="Document Management Software"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.tech_other" label="Other Software"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <!-- <v-text-field v-model="editData.tech_paperless" label="Paperless Office"></v-text-field> -->
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    export default {
        name: 'TechnologyUse',
        props: [
            'editData'
        ],
        data: () => ({
            name: 'TechnologyUse'
        })
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/TechnologyUse.vue